import { useMessageChannelContext } from '@healthhub/react-ui';
import { useTranslation } from 'react-i18next';
import { NavigationType, useNavigate, useNavigationType } from 'react-router';

import { HealthHubIcon, PageNotFoundBackground, PageNotFoundIcon } from '@shared/assets';
import { useLayoutViewContext } from '@shared/context';
import { MESSAGE_ACTION } from '@shared/utils/bridge';

import { Button } from '../Button';

const PageNotFound = () => {
  const { isPortalView } = useLayoutViewContext();
  const { sendMessageToNative } = useMessageChannelContext();

  const { t } = useTranslation();
  const routerNavigate = useNavigate();
  const navigationType = useNavigationType();

  const handleBack = () => {
    if (isPortalView) {
      routerNavigate(-1);
      return;
    }

    if (navigationType === NavigationType.Push) {
      routerNavigate(-1);
    } else {
      sendMessageToNative(MESSAGE_ACTION.back());
    }
  };

  return (
    <>
      <img alt="" className="absolute bottom-0 right-0 h-2/5 overflow-hidden md:h-5/6" src={PageNotFoundBackground} />
      <div>
        <div className="flex w-full justify-center border-b-2 border-solid border-secondary-green">
          <img alt="" src={HealthHubIcon} />
        </div>
        <div className="flex flex-col items-center justify-center gap-y-10 p-10 lg:p-20" lang="en">
          <span className="text-2xl font-semibold">Page Not Found.</span>
          <span className="text-center text-base font-semibold">
            The page you are looking for does not exist or has been moved.
          </span>
          <img alt="" src={PageNotFoundIcon} />
          <Button className="w-80" onClick={handleBack} variant="primary">
            {t('back')}
          </Button>
        </div>
      </div>
    </>
  );
};
export default PageNotFound;
